<script setup lang="ts">
import type { TtLocationFragment } from '#graphql-operations'

const props = defineProps<{
  store: TtLocationFragment
}>()

const store = computed(() => props.store)
const { public: config } = useRuntimeConfig()
const filloutId = computed<string>(() => config?.fillout?.contactForm || '')

const embedCode = computed(() => {
  let script = `<`
  script += `script type="text/javascript" src="https://server.fillout.com/embed/v1/" async></`
  script += `script><div
      class="service-request-form__form"
      style="height:500px;"
      data-fillout-id="${filloutId.value}"
      data-fillout-embed-type="standard"
      data-fillout-inherit-parameters
      data-store="${store.value?.code || ''}"
      data-fillout-dynamic-resize
    ></div>`

  return script
})

// const { load } = useScriptFillout()

// onMounted(async () => {
//   await load()
// })
</script>

<template>
  <LazyUiDialog
    name="store-contact-dialog"
    dialog-type="responsive"
  >
    <UiEmbed
      v-if="embedCode"
      :embed-code="embedCode"
      persist
    />
    <!-- <pre>store: {{ store }}</pre> -->
  </LazyUiDialog>
</template>
